export default "__VITE_ASSET__DiOWWiQS__"